import React, {HTMLAttributes, ReactNode} from 'react';
import PageTitle from '../page-title';

type QuestionBodyProps = {
  children?: ReactNode;
  title: string;
};

export function QuestionTitle({children, ...rest}: {children?: ReactNode}) {
  return (
    <div className={'pb-4 mb-4 border-b border-[#e3e4e6]'} {...rest}>
      <PageTitle>{children}</PageTitle>
    </div>
  );
}

export const QuestionBody: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return <div className={` mb-[50px] ${className}`}>{children}</div>;
};

export function QuestionContainer({children, title}: QuestionBodyProps) {
  return (
    <div
      className={
        'w-[886px] min-h-[484px] px-[30px] m-auto bg-white rounded text-[15px]'
      }
    >
      <h1
        className={'border-b border-[#e9eced] m-0 pt-5 pb-4 text-h3 font-black'}
      >
        {title}
      </h1>
      <div className={'py-[30px]'}>{children}</div>
    </div>
  );
}

const Question = {
  QuestionContainer,
  QuestionBody,
  PageTitle: QuestionTitle,
};
export default Question;
